import { MediaItem } from '@repo/roche-xx-shared';
import React from 'react';
import { DataSearchView } from '../../search/data-search';
import { RocheEventListItem } from '../../search/data-search/list-items/event-list-item';
import {
  fetchInvestorEventsList,
  fetchInvestorEventsSubtabs,
  fetchInvestorEventsTabs,
} from '../../search/data-search/queries';
import { EventItem } from '../../search/data-search/types';
import { SearchTrackingType } from '../../search/tracking';
import { Props } from './types';

export const RocheInvestorEventsList = ({ slot }: Props): JSX.Element => {
  return (
    <DataSearchView<EventItem | MediaItem>
      slot={slot}
      searchTrackingType={SearchTrackingType.INVESTOR_EVENTS}
      tabName='year'
      subtabName='tag'
      pageName='page'
      fetchTabs={fetchInvestorEventsTabs}
      fetchSubtabs={fetchInvestorEventsSubtabs}
      fetchList={fetchInvestorEventsList}
      itemRenderer={(item, index, trackingData) => (
        <RocheEventListItem key={`${item.Category}-${index}`} item={item} trackingData={trackingData} />
      )}
    />
  );
};
